import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

interface Props {
  error: Error;
  title: string;
}

export function HeldEmailLoadError({ error, title }: Props) {
  return (
    <Alert color="red" icon={<IconAlertCircle size={18} />} title={title}>
      {error.message}
    </Alert>
  );
}
